import '@/utils/CancellablePromise';
import Vue from 'vue';

import router from './router';
import store from './store';
import './plugins/element.js';
import '@/utils/api/install';

import '@/assets/style/base.scss';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Korea');

import AppWrapper from './AppWrapper.vue';

Vue.config.productionTip = false;

Vue.config.errorHandler = (err: Error, vm: Vue, info: string) => {
    try {
        Vue.nextTick(() => {
            Vue.prototype.$notify.info({
                message: err.message || '다시 시도해 주세요.',
                title: 'vue error handler',
            });
            console.error(err);
            console.error(vm, info);
        })
    } catch (error) {
        console.error('[custom error-handler Error (Vue.nextTick)]')
        console.error(error);
    }
};

Vue.prototype.customRouterErrorHandler = (err: Error, info: string) => {
    try {
        Vue.nextTick(() => {
            Vue.prototype.$notify.info({
                message: err.message || '다시 시도해 주세요.',
                title: 'vue router error handler',
            });
            console.error(err, info);
        })
    } catch (error) {
        console.error('[custom router-error-handler Error (Vue.nextTick)]')
        console.error(error);
    }
};

new Vue({
    router,
    store,
    render: (h) => h(AppWrapper),
}).$mount('#app');
